module.exports = __webpack_public_path__ + "img/lead-05e.9b1fd92f.png";